import React, { useState } from "react";
import { Button } from "primereact/button";
import config from "../../../config";

const ServiceGallery = ({ gallery = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!gallery || gallery.length === 0) return <span>No images</span>;

  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? gallery.length - 1 : prev - 1));
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === gallery.length - 1 ? 0 : prev + 1));
  };

  const currentImage = gallery[currentIndex];
  const imageUrl = `${config.API_BASE_URL}/gallery/download/${currentImage.id}`;

  return (
    <div
      className="flex flex-column align-items-center justify-content-center gap-1"
      style={{ position: "relative", width: "90px" }}
    >
      <div
        className="flex align-items-center justify-content-center gap-2"
        style={{ position: "relative", width: "90px", height: "70px" }}
      >
        {/* Arrow buttons only if multiple images */}
        {gallery.length > 1 && (
          <>
            <Button
              icon="pi pi-chevron-left"
              className="p-button-rounded p-button-text"
              style={{
                position: "absolute",
                left: -8,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 2,
                width: "1.5rem",
                height: "1.5rem",
              }}
              onClick={handlePrev}
            />
            <Button
              icon="pi pi-chevron-right"
              className="p-button-rounded p-button-text"
              style={{
                position: "absolute",
                right: -8,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 2,
                width: "1.5rem",
                height: "1.5rem",
              }}
              onClick={handleNext}
            />
          </>
        )}

        {/* Image */}
        <img
          src={imageUrl}
          alt={`service-${currentIndex + 1}`}
          style={{
            width: "80px",
            height: "60px",
            objectFit: "cover",
            borderRadius: "6px",
            border: "1px solid #ddd",
          }}
        />
      </div>

      {/* Current / Total */}
      {gallery.length > 1 && (
        <span style={{ fontSize: "12px", color: "#555" }}>
          {currentIndex + 1} / {gallery.length}
        </span>
      )}
    </div>
  );
};

export default ServiceGallery;
